import axios from "axios";
import {
  getI18nLanguageStorage,
  getSelectedFarmIdFromStorage,
} from "shared/storageUtils";

export const createServiceHandler = () => {
  const instance = axios.create({
    // params: {
    //   lng: getI18nLanguageStorage() || "pt-BR"
    // },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      usuario: localStorage.getItem("Email"),
      user: localStorage.getItem("Login"),
      userId: localStorage.getItem("IdUsuario"),
      farmId: getSelectedFarmIdFromStorage(),
      userEmail: localStorage.getItem("Email"),
      "Accept-Language": getI18nLanguageStorage() || "pt-BR",
    },
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        window.location.href = "/login";
        localStorage.clear();
        return Promise.resolve({});
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
